import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import { ProjectRequestDTO, ProjectDTO, SelectionOptions, UserDTO } from '@/models';
import { buildProjectRequestData, getUserDisplayInfo } from '@/services';

interface ProjectValidationError {
  name: string;
  sponsorId: string;
  managerId: string;
  projectType: string;
  startDate: string;
  endDate: string;
}

const buildEmptyProjectValidationErrors = (): ProjectValidationError => ({
  name: '',
  sponsorId: '',
  managerId: '',
  projectType: '',
  startDate: '',
  endDate: ''
});

@Component
class ProjectInformationMixin extends Vue {
  protected projectFormData: ProjectRequestDTO;
  protected projectFormValidationErrors = buildEmptyProjectValidationErrors();

  async buildProjectData(project?: ProjectDTO): Promise<ProjectRequestDTO> {
    return buildProjectRequestData(project);
  }

  buildUserOptions(): SelectionOptions {
    const users: UserDTO[] = this.$store.getters['user/users'];
    return (users || [])
      .filter(user => user.id && user.code)
      .map(user => ({
        text: getUserDisplayInfo(user),
        value: '' + user.id
      }));
  }

  validateProjectData(): boolean {
    const isRequiredFieldsValid = this.validateRequiredFields();
    const isDateFieldsValid = this.validateDateFields();
    return isRequiredFieldsValid && isDateFieldsValid;
  }

  validateRequiredFields(): boolean {
    const requiredFields = ['name', 'projectType', 'sponsorId', 'managerId'] as Array<keyof ProjectValidationError>;
    let isValid = true;
    requiredFields.forEach(field => {
      if (this.projectFormData[field]) {
        this.projectFormValidationErrors[field] = '';
      } else {
        this.projectFormValidationErrors[field] = 'This field is required';
        isValid = false;
      }
    });
    return isValid;
  }

  validateDateFields(): boolean {
    const { startDate, endDate } = this.projectFormData;
    if (startDate && endDate) {
      const isValid = moment(startDate).isBefore(moment(endDate));
      if (isValid) {
        this.projectFormValidationErrors.startDate = '';
        this.projectFormValidationErrors.endDate = '';
      } else {
        this.projectFormValidationErrors.startDate = 'Start date must be before end date';
        this.projectFormValidationErrors.endDate = 'End date must be after start date';
      }
      return isValid;
    }

    this.projectFormValidationErrors.startDate = '';
    this.projectFormValidationErrors.endDate = '';
    return true;
  }
}

export { ProjectValidationError };
export default ProjectInformationMixin;
